import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
declare  var jQuery:  any;
declare const bolt: any;

@Component({
  selector: 'app-addaddress',
  templateUrl: './addaddress.component.html',
  styleUrls: ['./addaddress.component.scss']
})
export class AddaddressComponent implements OnInit {

	addressList: any = "";

  constructor(
  	public authService: AuthService,
  ) { }

  ngOnInit(): void {

  	this.authService.getAddress().then((data) => {
	      this.addressList = data;
	      console.log(this.addressList);
	    });
  }

}
